import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=55285981&scoped=true"
import script from "./CartIcon.vue?vue&type=script&lang=js"
export * from "./CartIcon.vue?vue&type=script&lang=js"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=55285981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55285981",
  null
  
)

export default component.exports